var G = Object.defineProperty;
var V = (e, t, r) => t in e ? G(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var g = (e, t, r) => (V(e, typeof t != "symbol" ? t + "" : t, r), r);
import { jsx as v } from "react/jsx-runtime";
import { createContext as D, useRef as B, useCallback as Z, createElement as C, useEffect as ee, forwardRef as N, useState as te, Suspense as re } from "react";
import { QueryClient as $, dehydrate as ne, useSuspenseQuery as oe, hydrate as se, QueryClientProvider as ie } from "@tanstack/react-query";
import { I18nextProvider as ae, useTranslation as ce } from "react-i18next";
import "i18next";
var le = /* @__PURE__ */ D({}), z = "id";
function ue(e) {
  return e === void 0 && (e = z), (e ? e + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var de = /* @__PURE__ */ D(ue);
function fe(e) {
  var t = e.children, r = e.prefix, n = r === void 0 ? z : r, o = B(0), s = Z(function(i) {
    return i === void 0 && (i = n), (i ? i + "-" : "") + ++o.current;
  }, [n]);
  return /* @__PURE__ */ C(de.Provider, {
    value: s
  }, t);
}
function pe(e) {
  var t = e.children, r = e.unstable_system;
  return /* @__PURE__ */ C(le.Provider, {
    value: r
  }, t);
}
var he = {};
function ye(e) {
  var t = e.unstable_prefix, r = e.unstable_system, n = r === void 0 ? he : r, o = e.children;
  return /* @__PURE__ */ C(fe, {
    prefix: t
  }, /* @__PURE__ */ C(pe, {
    unstable_system: n
  }, o));
}
const me = ({ children: e, i18nInstance: t }) => /* @__PURE__ */ v(ae, { i18n: t, children: e }), ge = (e = "label") => {
  const t = Array.isArray(e) ? e : [e];
  return ce(t);
}, ve = () => {
  const { t: e } = ge("label");
  return /* @__PURE__ */ v("div", { "data-testid": "default-loading-fallback", children: e("CX_ERROR_LOADING_TEXT", { ns: "label" }) });
}, xe = "application/json", W = "Content-Type", w = Symbol(), X = Symbol();
function M(e = {}) {
  var t;
  const r = e instanceof Array ? Object.fromEntries(e) : e;
  return (t = Object.entries(r).find(([n]) => n.toLowerCase() === W.toLowerCase())) === null || t === void 0 ? void 0 : t[1];
}
function H(e) {
  return /^application\/.*json.*/.test(e);
}
const _ = function(e, t, r = !1) {
  return Object.entries(t).reduce((n, [o, s]) => {
    const i = e[o];
    return Array.isArray(i) && Array.isArray(s) ? n[o] = r ? [...i, ...s] : s : typeof i == "object" && typeof s == "object" ? n[o] = _(i, s, r) : n[o] = s, n;
  }, { ...e });
}, A = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(e, t = !0, r = !1, ...n) {
    const o = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);
    if (t && !o)
      throw new Error(e + " is not defined");
    return r && o ? new o(...n) : o;
  }
};
function Ee(e, t = !1) {
  A.options = t ? e : _(A.options, e);
}
function _e(e, t = !1) {
  A.polyfills = t ? e : _(A.polyfills, e);
}
function ke(e) {
  A.errorType = e;
}
const be = (e) => (t) => e.reduceRight((r, n) => n(r), t) || t;
class K extends Error {
}
const we = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  e = e._addons.reduce((a, l) => l.beforeRequest && l.beforeRequest(a, e._options, t) || a, e);
  const { _url: r, _options: n, _config: o, _catchers: s, _resolvers: i, _middlewares: c, _addons: d } = e, h = new Map(s), f = _(o.options, n);
  let E = r;
  const b = be(c)((a, l) => (E = a, o.polyfill("fetch")(a, l)))(r, f), T = new Error(), L = b.catch((a) => {
    throw { [w]: a };
  }).then((a) => {
    var l;
    if (!a.ok) {
      const u = new K();
      if (u.cause = T, u.stack = u.stack + `
CAUSE: ` + T.stack, u.response = a, u.status = a.status, u.url = E, a.type === "opaque")
        throw u;
      const p = o.errorType === "json" || ((l = a.headers.get("Content-Type")) === null || l === void 0 ? void 0 : l.split(";")[0]) === "application/json";
      return (o.errorType ? p ? a.text() : a[o.errorType]() : Promise.resolve(a.body)).then((y) => {
        throw u.message = typeof y == "string" ? y : a.statusText, y && (p && typeof y == "string" ? (u.text = y, u.json = JSON.parse(y)) : u[o.errorType] = y), u;
      });
    }
    return a;
  }), x = (a) => a.catch((l) => {
    const u = Object.prototype.hasOwnProperty.call(l, w), p = u ? l[w] : l, P = (p == null ? void 0 : p.status) && h.get(p.status) || h.get(p == null ? void 0 : p.name) || u && h.has(w) && h.get(w);
    if (P)
      return P(p, e);
    const y = h.get(X);
    if (y)
      return y(p, e);
    throw p;
  }), m = (a) => (l) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ x(a ? L.then((u) => u && u[a]()).then((u) => l ? l(u) : u) : L.then((u) => l ? l(u) : u)), O = {
    _wretchReq: e,
    _fetchReq: b,
    _sharedState: t,
    res: m(null),
    json: m("json"),
    blob: m("blob"),
    formData: m("formData"),
    arrayBuffer: m("arrayBuffer"),
    text: m("text"),
    error(a, l) {
      return h.set(a, l), this;
    },
    badRequest(a) {
      return this.error(400, a);
    },
    unauthorized(a) {
      return this.error(401, a);
    },
    forbidden(a) {
      return this.error(403, a);
    },
    notFound(a) {
      return this.error(404, a);
    },
    timeout(a) {
      return this.error(408, a);
    },
    internalError(a) {
      return this.error(500, a);
    },
    fetchError(a) {
      return this.error(w, a);
    }
  }, S = d.reduce((a, l) => ({
    ...a,
    ...typeof l.resolver == "function" ? l.resolver(a) : l.resolver
  }), O);
  return i.reduce((a, l) => l(a, e), S);
}, Ce = {
  _url: "",
  _options: {},
  _config: A,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(e) {
    return { ...this, _addons: [...this._addons, e], ...e.wretch };
  },
  errorType(e) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: e
      }
    };
  },
  polyfills(e, t = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: t ? e : _(this._config.polyfills, e)
      }
    };
  },
  url(e, t = !1) {
    if (t)
      return { ...this, _url: e };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + e + "?" + r[1] : this._url + e
    };
  },
  options(e, t = !1) {
    return { ...this, _options: t ? e : _(this._options, e) };
  },
  headers(e) {
    const t = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
    return { ...this, _options: _(this._options, { headers: t }) };
  },
  accept(e) {
    return this.headers({ Accept: e });
  },
  content(e) {
    return this.headers({ [W]: e });
  },
  auth(e) {
    return this.headers({ Authorization: e });
  },
  catcher(e, t) {
    const r = new Map(this._catchers);
    return r.set(e, t), { ...this, _catchers: r };
  },
  catcherFallback(e) {
    return this.catcher(X, e);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(e, t = !1) {
    return { ...this, _resolvers: t ? [e] : [...this._resolvers, e] };
  },
  defer(e, t = !1) {
    return {
      ...this,
      _deferred: t ? [e] : [...this._deferred, e]
    };
  },
  middlewares(e, t = !1) {
    return {
      ...this,
      _middlewares: t ? e : [...this._middlewares, ...e]
    };
  },
  fetch(e = this._options.method, t = "", r = null) {
    let n = this.url(t).options({ method: e });
    const o = M(n._options.headers), s = this._config.polyfill("FormData", !1), i = typeof r == "object" && !(s && r instanceof s) && (!n._options.headers || !o || H(o));
    return n = r ? i ? n.json(r, o) : n.body(r) : n, we(n._deferred.reduce((c, d) => d(c, c._url, c._options), n));
  },
  get(e = "") {
    return this.fetch("GET", e);
  },
  delete(e = "") {
    return this.fetch("DELETE", e);
  },
  put(e, t = "") {
    return this.fetch("PUT", t, e);
  },
  post(e, t = "") {
    return this.fetch("POST", t, e);
  },
  patch(e, t = "") {
    return this.fetch("PATCH", t, e);
  },
  head(e = "") {
    return this.fetch("HEAD", e);
  },
  opts(e = "") {
    return this.fetch("OPTIONS", e);
  },
  body(e) {
    return { ...this, _options: { ...this._options, body: e } };
  },
  json(e, t) {
    const r = M(this._options.headers);
    return this.content(t || H(r) && r || xe).body(JSON.stringify(e));
  }
};
function k(e = "", t = {}) {
  return { ...Ce, _url: e, _options: t };
}
k.default = k;
k.options = Ee;
k.errorType = ke;
k.polyfills = _e;
k.WretchError = K;
class Ae extends Error {
  constructor(r, n, o, s, i) {
    super(r);
    g(this, "statusCode");
    g(this, "endpoint");
    g(this, "args");
    g(this, "response");
    this.name = "ApiError", this.statusCode = n, this.endpoint = o, this.args = s, this.response = i;
  }
}
class F extends Ae {
  constructor(t, r, n, o) {
    super(`Client error ${t} occurred while fetching ${r}`, t, r, n, o), this.name = "Api4xxError";
  }
}
class Te extends F {
  constructor(t, r, n) {
    super(404, t, r, n), this.name = "Api404Error";
  }
}
class Le extends F {
  constructor(t, r, n) {
    super(400, t, r, n), this.name = "Api400Error";
  }
}
class Oe {
  constructor(t = {}) {
    g(this, "logger");
    g(this, "notFoundLogLevel");
    g(this, "badRequestLogLevel");
    g(this, "other4xxLogLevel");
    this.logger = t.logger, this.notFoundLogLevel = t.notFoundLogLevel || "info", this.badRequestLogLevel = t.badRequestLogLevel || "warn", this.other4xxLogLevel = t.other4xxLogLevel || "warn";
  }
  log(t, r, n) {
    this.logger && this.logger[t](r, n);
  }
  async handleApiError(t, r, n) {
    if (!(t instanceof Response))
      throw t;
    const { status: o } = t;
    if (o === 404) {
      const s = new Te(r, n, t);
      return this.log(this.notFoundLogLevel, s.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    if (o === 400) {
      const s = new Le(r, n, t);
      return this.log(this.badRequestLogLevel, s.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    if (o >= 400 && o < 500) {
      const s = new F(o, r, n, t);
      return this.log(this.other4xxLogLevel, s.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    throw t;
  }
}
const Re = (e, t) => {
  const r = new Oe(t);
  return e.catcher(404, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(400, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(401, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(403, async (n) => (await r.handleApiError(n.response, n.url), null)).catcherFallback(async (n) => {
    if (n.status >= 400 && n.status < 500)
      return await r.handleApiError(n.response, n.url), null;
    throw n;
  });
};
/*! js-cookie v3.0.5 | MIT */
function R(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      e[n] = r[n];
  }
  return e;
}
var Se = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function I(e, t) {
  function r(o, s, i) {
    if (!(typeof document > "u")) {
      i = R({}, t, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), o = encodeURIComponent(o).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var c = "";
      for (var d in i)
        i[d] && (c += "; " + d, i[d] !== !0 && (c += "=" + i[d].split(";")[0]));
      return document.cookie = o + "=" + e.write(s, o) + c;
    }
  }
  function n(o) {
    if (!(typeof document > "u" || arguments.length && !o)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], i = {}, c = 0; c < s.length; c++) {
        var d = s[c].split("="), h = d.slice(1).join("=");
        try {
          var f = decodeURIComponent(d[0]);
          if (i[f] = e.read(h, f), o === f)
            break;
        } catch {
        }
      }
      return o ? i[o] : i;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(o, s) {
        r(
          o,
          "",
          R({}, s, {
            expires: -1
          })
        );
      },
      withAttributes: function(o) {
        return I(this.converter, R({}, this.attributes, o));
      },
      withConverter: function(o) {
        return I(R({}, this.converter, o), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
I(Se, { path: "/" });
D({});
const Pe = () => `${typeof window < "u" ? window.location.origin : ""}/api/cx`, Y = async (e = Pe(), t, r) => {
  const { id: n, level: o, repub: s } = t, i = new URL(`${e}/v1/evergreen/${o}`);
  return Re(
    k(`${i.toString()}?id=${n}`, {
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        repub: s,
        ...(r == null ? void 0 : r.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    r
  ).get().json();
}, J = ({ id: e, repub: t }) => [`text-block-${e}`, t], Ve = async (e, t) => {
  const r = new $(), n = {
    id: e.id,
    level: e.level,
    repub: e.repub
  }, o = await Y(t, n, { nocache: e.nocache });
  return await r.prefetchQuery({
    queryFn: () => o,
    queryKey: J(n)
  }), {
    componentArgs: {
      dehydratedState: ne(r),
      id: n.id,
      level: n.level,
      repub: n.repub
    }
  };
}, je = (e) => {
  ee(() => {
    const t = e.current;
    if (t) {
      const r = t.getElementsByTagName("header"), n = (s) => {
        !t.contains(s.target) && Array.from(r).forEach((c) => {
          c.classList.contains("open") && c.classList.remove("open");
        });
      }, o = (s) => {
        s.stopImmediatePropagation(), Array.from(r).forEach((i) => {
          i.contains(s.target) && i.classList.contains("open") ? i.classList.remove("open") : i.contains(s.target) && !i.classList.contains("open") && i.classList.add("open"), !i.contains(s.target) && i.classList.contains("open") && i.classList.remove("open");
        });
      };
      return t.addEventListener("click", o), document.addEventListener("click", n), () => {
        t == null || t.removeEventListener("click", o), document.removeEventListener("click", n);
      };
    }
  }, [e]);
};
function Ie(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var De = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, j = /* @__PURE__ */ Ie(
  function(e) {
    return De.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Fe = function() {
  const t = Array.prototype.slice.call(arguments).filter(Boolean), r = {}, n = [];
  t.forEach((s) => {
    (s ? s.split(" ") : []).forEach((c) => {
      if (c.startsWith("atm_")) {
        const [, d] = c.split("_");
        r[d] = c;
      } else
        n.push(c);
    });
  });
  const o = [];
  for (const s in r)
    Object.prototype.hasOwnProperty.call(r, s) && o.push(r[s]);
  return o.push(...n), o.join(" ");
}, U = Fe, Ne = (e) => e.toUpperCase() === e, Me = (e) => (t) => e.indexOf(t) === -1, Q = (e, t) => {
  const r = {};
  return Object.keys(e).filter(Me(t)).forEach((n) => {
    r[n] = e[n];
  }), r;
};
function He(e, t, r) {
  const n = Q(t, r);
  if (!e) {
    const o = typeof j == "function" ? { default: j } : j;
    Object.keys(n).forEach((s) => {
      o.default(s) || delete n[s];
    });
  }
  return n;
}
var Ue = (e, t) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof e == "number" && isFinite(e))
      return;
    const r = typeof e == "object" ? JSON.stringify(e) : String(e);
    console.warn(
      `An interpolation evaluated to '${r}' in the component '${t}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, qe = 0;
function q(e) {
  let t = "";
  return process.env.NODE_ENV === "test" && (t += `mocked-styled-${qe++}`, e && e.__wyw_meta && e.__wyw_meta.className && (t += ` ${e.__wyw_meta.className}`)), (r) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(r))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const n = (s, i) => {
      const { as: c = e, class: d = t } = s, h = r.propsAsIs === void 0 ? !(typeof c == "string" && c.indexOf("-") === -1 && !Ne(c[0])) : r.propsAsIs, f = He(h, s, [
        "as",
        "class"
      ]);
      f.ref = i, f.className = r.atomic ? U(r.class, f.className || d) : U(f.className || d, r.class);
      const { vars: E } = r;
      if (E) {
        const b = {};
        for (const x in E) {
          const m = E[x], O = m[0], S = m[1] || "", a = typeof O == "function" ? O(s) : O;
          Ue(a, r.name), b[`--${x}`] = `${a}${S}`;
        }
        const T = f.style || {}, L = Object.keys(T);
        L.length > 0 && L.forEach((x) => {
          b[x] = T[x];
        }), f.style = b;
      }
      return e.__wyw_meta && e !== c ? (f.as = c, C(e, f)) : C(c, f);
    }, o = N ? N(n) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (s) => {
        const i = Q(s, ["innerRef"]);
        return n(i, s.innerRef);
      }
    );
    return o.displayName = r.name, o.__wyw_meta = {
      className: r.class || t,
      extends: e
    }, o;
  };
}
var Be = process.env.NODE_ENV !== "production" ? new Proxy(q, {
  get(e, t) {
    return e(t);
  }
}) : q;
const $e = /* @__PURE__ */ Be("article")({
  name: "EvergreenContainer",
  class: "EvergreenContainer_e42wd3u",
  propsAsIs: !1
}), ze = ({ dataApiEndpoint: e, ...t }) => {
  const r = B(null);
  je(r);
  const { data: n } = oe({
    queryFn: () => Y(e, t, {
      logger: console
    }),
    queryKey: J(t)
  });
  return n != null && n.body ? /* @__PURE__ */ v($e, { dangerouslySetInnerHTML: { __html: n.body }, "data-testid": "text-block", ref: r }) : null;
}, We = (e) => new $({
  defaultOptions: {
    queries: {
      gcTime: e ? 0 : void 0,
      refetchOnMount: !!e,
      staleTime: e ? 0 : 1 / 0
    }
  }
});
function Ze({ dehydratedState: e, nocache: t, ...r }) {
  const [n] = te(() => {
    const o = We(t);
    return se(o, e), o;
  });
  return /* @__PURE__ */ v(ye, { children: /* @__PURE__ */ v(ie, { client: n, children: /* @__PURE__ */ v(me, { i18nInstance: r.i18n, children: /* @__PURE__ */ v(re, { fallback: /* @__PURE__ */ v(ve, {}), children: /* @__PURE__ */ v(ze, { ...r }) }) }) }) });
}
export {
  Ze as TextBlockWithQuery,
  Ve as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
